import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-carto',
  templateUrl: './carto.component.html',
  styleUrls: ['./carto.component.scss'],
})
export class CartoComponent implements OnInit {
  oktaToken = '';
  cartoIframeUrl: SafeResourceUrl;
  iframe: HTMLIFrameElement;
  constructor(
    private sanitizer: DomSanitizer
  ) {
    this.cartoIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.cartoIframeUrl);
  }

  ngOnInit(): void {
    this.iframe = document.getElementById('myIframe') as HTMLIFrameElement;
  }
}
